/*
 * 다운로드 상세 조회
 */

import React, { Component } from 'react';
import {
	Card
	, CardBody
	, CardHeader
	, CardTitle
	, Container
	, Form
	, Row
	, Col
	, Button
	, Input
	, Label
	, FormGroup
} from "reactstrap";
import NumberFormat from 'react-number-format';
import moment from 'moment';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Select from 'react-select';
import axios from "axios";
const pagenationOptions = {
	totalSize: 0,
	onSizePerPageChange: (sizePerPage, page) => { }
	, onPageChange: (page, sizePerPage) => { }
	, paginationShowsTotal: true
};
const options = [
	{
		value: 'tableNm',
		label: '테이블명'
	},
	{
		value: 'fileNm',
		label: '파일명'
	}
];
let loginId = JSON.parse(localStorage.getItem('userInfo')).id; // 로그인 ID
class DownloadBox extends Component {
	constructor(props) {
		super(props);
		const urlParams = new URLSearchParams(window.location.search);
		let envUrl = global.downloadUrl + "/env";
		const downloadFileDurationHours = 0;
		let count = 0;
		let initialTableColumns = [];
		if (loginId === 'admin') {
			initialTableColumns = [
				{
					dataField: "makeDate",
					text: "날짜",
					sort: true
				},
				{
					dataField: "tableNm",
					text: "테이블명",
					sort: true
				},
				{
					dataField: "fileNm",
					text: "파일명",
					sort: true
				},
				{
					dataField: "size",
					text: "사이즈",
					sort: true
				},
				{
					dataField: "loginId",
					text: "아이디",
					sort: true
				},
				{
					dataField: "downloadSt",
					text: "다운로드 상태",
					sort: true
				},
				{
					dataField: "ip",
					text: "아이피",
					sort: true
				},
			];
		} else {
			initialTableColumns = [
				{
					dataField: "makeDate",
					text: "날짜",
					sort: true
				},
				{
					dataField: "tableNm",
					text: "테이블명",
					sort: true
				},
				{
					dataField: "fileNm",
					text: "파일명",
					sort: true
				},
				{
					dataField: "size",
					text: "사이즈",
					sort: true
				},
				{
					dataField: "downloadSt",
					text: "다운로드 상태",
					sort: true
				}
			];
		}
		this.state = {
			data: {}
			, tableColumns: initialTableColumns
			, tableData: []
			, tableNm: ""
			, envUrl: envUrl
			, downloadFileDurationHours: downloadFileDurationHours
			, count: count
			, onTableChange: this.handleTableChange
			, selectedOption: {
				value: 'tableNm',
				label: '테이블명'
			}
			, searchText : ""
		}
	}
	handleTableChange = (type, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }) => {
		console.log("this.state.searchText",this.state.searchText);
		if((this.state.searchText == '' || this.state.searchText == null)){
			this.componentDidMount(null, page, sizePerPage, filters, sortField, sortOrder, cellEdit);
		}else{
			this.handleSearch(null, page, sizePerPage, filters, sortField, sortOrder, cellEdit);
		}   
	}
	componentDidMount(type, page, sizePerPage, filters, sortField, sortOrder, cellEdit){
		let reqParams = ""; // 페이지 정보Param
		if (!page) {page = 0;}
		if (page >= 1) {page = page - 1;}
		reqParams += "&page=" + page;
		if (!sizePerPage) {sizePerPage = 10;}
		reqParams += "&size=" + sizePerPage;
		if(sortField == undefined){reqParams += "&sort=seq,desc"}
		if (sortField != undefined && sortOrder != undefined) {reqParams += "&sort=" + sortField + "," + sortOrder;}
		let downloadBoxUrl;
		if (loginId === 'admin') {  // 관리자 로그인일 경우
			downloadBoxUrl = global.dmApiUrl + "/downloadBoxes?sort=seq,desc"
		} else {  // 그 외 일반사용자
			downloadBoxUrl = global.dmApiUrl + "/downloadBox/advSearch?tblAlias=downloadBoxes&schColumns=loginId&schKeywords="+loginId+"&columnTypes=STRING&columnFormats=null&comparisonOperators=LK&conditions=AND&";
		}
		fetch(this.state.envUrl).then(response => response.json()).then(envList => {
			var aaa = envList.downloadFileDurationHours;
			this.setState({
				downloadFileDurationHours: aaa
			});
		})
		fetch(downloadBoxUrl+reqParams).then(response => response.json())
			.then(data => {
				let tableData = [];
				if (data._embedded == null) {
					return;
				}
				var tblDataList = data._embedded['downloadBoxes'];
				for (var i = 0; i < tblDataList.length; i++) {
					var downloadSt2 = null;
					var fileNm2 = null;
					downloadSt2 = tblDataList[i].downloadSt;  // 다운로드 상태
					fileNm2 = tblDataList[i].fileNm;  // 파일명
					var makeDate2 = null;
					makeDate2 = tblDataList[i].makeDate;
					tblDataList[i].makeDate = moment(makeDate2).format('YYYY.MM.DD HH:mm');
					var t1 = moment(makeDate2).format('YYYY.MM.DD HH:mm');
					var t2 = moment();
					var t3 = moment.duration(t2.diff(t1)).asHours();
					var tempTblData = tblDataList[i];
					tempTblData.name = (page - 1) * sizePerPage + i + 1;
					if (downloadSt2 === "다운로드") { // 다운로드 상태가 다운로드일 경우 다운경로로 변경
						if (t3 >= this.state.downloadFileDurationHours) {
							var downloadSt4 = "삭제됨";
							tblDataList[i].downloadSt = downloadSt4;
						} else {
							var downloadSt3 = <a href={global.downloadUrl + "/" + fileNm2}>다운로드</a>
							tblDataList[i].downloadSt = downloadSt3;
						}
					}
				}
				tableData = tblDataList;
				let pageNumber = data.page.totalElements    
				pagenationOptions.totalSize = pageNumber;
				this.setState({
					tableData: tableData
					, count: pageNumber
					, totalSize: pageNumber
				});
			});
	}

	onChange = (e) => {
		this.setState({
			searchText: e.target.value
		});
	};

	handleSearch(type, page, sizePerPage, filters, sortField, sortOrder, cellEdit) {
		let reqParams = ""; // 페이지 정보Param
		if (!page) {page = 0;}
		if (page >= 1) {page = page - 1;}
		reqParams += "&page=" + page;
		if (!sizePerPage) {sizePerPage = 10;}
		reqParams += "&size=" + sizePerPage;
		if(sortField == undefined){reqParams += "&sort=seq,desc"}
		if (sortField != undefined && sortOrder != undefined) {reqParams += "&sort=" + sortField + "," + sortOrder;}
		let downloadBoxUrl = "";
		console.log("VALUE",this.state.selectedOption.value)
		console.log("text",this.state.searchText)
		
		if (loginId === 'admin') {  // 관리자 로그인일 경우
			downloadBoxUrl += global.dmApiUrl + "/downloadBox/advSearch?tblAlias=downloadBoxes&schColumns=" + this.state.selectedOption.value + "&schKeywords=" + this.state.searchText + "&columnTypes=STRING&columnFormats=null&comparisonOperators=LK&conditions=AND";
		} else {  // 그 외 일반사용자
			downloadBoxUrl += global.dmApiUrl + "/downloadBox/advSearch?tblAlias=downloadBoxes&schColumns=" + this.state.selectedOption.value + "&schKeywords=" + this.state.searchText + "&columnTypes=STRING&columnFormats=null&comparisonOperators=LK&conditions=AND";
			downloadBoxUrl += "&schColumns=loginId&schKeywords="+loginId+"&columnTypes=STRING&columnFormats=null&comparisonOperators=LK&conditions=AND&";
		}
		axios.get(downloadBoxUrl+reqParams).then(response=> {		
			console.log("response",response)	
			let tableData = [];
			this.state.tableData = [];
			var tblDataList = response.data._embedded['downloadBoxes'];
			console.log("tblDataList",tblDataList)
			for (var i = 0; i < tblDataList.length; i++) {
				var downloadSt2 = null;
				var fileNm2 = null;
				downloadSt2 = tblDataList[i].downloadSt;  // 다운로드 상태
				fileNm2 = tblDataList[i].fileNm;  // 파일명
				var makeDate2 = null;
				makeDate2 = tblDataList[i].makeDate;
				tblDataList[i].makeDate = moment(makeDate2).format('YYYY.MM.DD HH:mm');
				var t1 = moment(makeDate2).format('YYYY.MM.DD HH:mm');
				var t2 = moment();
				var t3 = moment.duration(t2.diff(t1)).asHours();
				var tempTblData = tblDataList[i];
				tempTblData.name = (page - 1) * sizePerPage + i + 1;
				if (downloadSt2 === "다운로드") { // 다운로드 상태가 다운로드일 경우 다운경로로 변경
					if (t3 >= this.state.downloadFileDurationHours) {
						var downloadSt4 = "삭제됨";
						tblDataList[i].downloadSt = downloadSt4;
					} else {
						var downloadSt3 = <a href={global.downloadUrl + "/" + fileNm2}>다운로드</a>
						tblDataList[i].downloadSt = downloadSt3;
					}
				}
			}
			tableData = tblDataList;
			let pageNumber = response.data.page.totalElements    
			pagenationOptions.totalSize = pageNumber;
			this.setState({
				tableData: tableData
				, count: pageNumber
				, totalSize: pageNumber
			});
		})
		
	}

	selectHandleChange = selectedOption => {
		this.setState({
			selectedOption
		})
	}
	appKeyPress = (e) => {
		if (e.key === 'Enter') {
			this.handleSearch();
		}
	}
	render() {
		var el = document.querySelector(".react-bootstrap-table.table-responsive > table");
		if (el) el.style.tableLayout = 'auto';
		const customStyles = {
			container: provided => ({
				...provided,
				width: 150
			})
		};
		return (
			<Container fluid className="p-0">
				<h1 className="h3 mb-3">다운로드 이력</h1>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<CardTitle tag="h5" className="mb-0">
									검색옵션
              					</CardTitle>
							</CardHeader>
							<CardBody>
								<Form inline>
									<FormGroup className="mb-2 mr-sm-2 mb-sm-0">
										<Select
											styles={customStyles}
											menuPlacement="auto"
											menuPosition="fixed"
											name="searchBox"
											value={this.state.selectedOption}
											onChange={this.selectHandleChange.bind(this)}
											options={options} />
									</FormGroup>
									<FormGroup className="mb-2 mr-sm-2 mb-sm-0">
										<Input
											style={{ height: "38px" }}
											type="text"
											placeholder="검색 조건을 입력하세요"
											name="searchText"
											onChange={this.onChange.bind(this)}
											onKeyPress={this.appKeyPress.bind(this)}
										/>
									</FormGroup>
									<Button className="float-right btn-primary" style={{ backgroundColor: "#47BAC1", borderColor: '#47BAC1' }} onClick={this.handleSearch.bind(this)}>검색</Button>
								</Form>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<CardTitle tag="h5">다운로드 목록(총 <NumberFormat value={this.state.count} displayType={'text'} thousandSeparator={true} /> 건)</CardTitle>
							</CardHeader>
							<CardBody>
								<BootstrapTable
									remote
									classes="table-striped table-hover"
									wrapperClasses="table-responsive"
									keyField="name"
									data={this.state.tableData}
									columns={this.state.tableColumns}
									bootstrap4
									bordered={false}
									pagination={paginationFactory(pagenationOptions)}
									noDataText="loading"
									paginationShowsTotal={true}
									onTableChange={this.state.onTableChange}
								/>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		);
	}
}

export default DownloadBox;